import { getStatusIconStyles } from "~/areas/projects/components/Observability/LiveStatusIcons/GetStatusIconStyles";
export function OutOfSyncIcon({ color }: {
    color?: string;
}) {
    const iconStyles = getStatusIconStyles(color || "#EA7325");
    return (<svg className={iconStyles} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.6143 4.66968C20.7214 3.77677 19.2713 3.77677 18.3784 4.66968L6.94922 16.0989C6.05631 16.9918 6.05631 18.4419 6.94922 19.3348C7.84213 20.2277 9.29221 20.2277 10.1851 19.3348L17.7141 11.7986V33.7142C17.7141 34.9785 18.7356 36 19.9999 36C21.2643 36 22.2858 34.9785 22.2858 33.7142V11.7986L29.8148 19.3276C30.7077 20.2205 32.1578 20.2205 33.0507 19.3276C33.9436 18.4347 33.9436 16.9847 33.0507 16.0917L21.6215 4.66254L21.6143 4.66968Z"/>
        </svg>);
}
